import { Component } from 'react';
import L from 'leaflet';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';

import LeafletComponentMixin from '../mixins/LeafletComponentMixin'; // TODO: kill these
import EventHandlerMixin from '../mixins/EventHandlerMixin';
import PropertyHelperMixin from '../mixins/PropertyHelperMixin';

import LoadingTileLayer from './LoadingTileLayer';

// Brief explanation of this weird class - it does not render the DOM elements for the map, but instead tracks state
// that is expected to affect rendering and tries to get Leaflet to behave as though part of the React lifecycle.
class TileLayer extends Component {

  constructor(props) {
    super(props);
    Object.assign(this, EventHandlerMixin);
    Object.assign(this, PropertyHelperMixin);
    Object.assign(this, LeafletComponentMixin);
    this.displayName = 'TileLayer';
    this.updatableProps = {
      opacity: function (layer) {
        layer.setOpacity(this.props.opacity / 100);
      },
      url: function (layer) {
        layer.setUrl(this.props.url);
      }
    };
  }

  buildOptions() {
    return omit(this.props, ['map', 'url']);
  }

  generateComponent() {
    if (this.props.spinner) {
      return new LoadingTileLayer(this.props.url, this.buildOptions());
    }
    return new L.TileLayer(this.props.url, this.buildOptions());
  }

  addToMap(map, component) {
    component.addTo(map);
  }

  render() {
    return null;
  }

}

TileLayer.propTypes = {
  map: PropTypes.object,
  opacity: PropTypes.number,
  spinner: PropTypes.bool,
  spinnerOpts: PropTypes.object, // using npm module 'spin'
  subdomains: PropTypes.array,
  url: PropTypes.string.isRequired
};

export { TileLayer };
